import React from 'react';
import PropTypes from 'prop-types';

const Divider = ({ height = '30px', backgroundColor = '#1d1e2f', margin = '20px 0' }) => {
    return (
        <div
            style={{
                height,
                backgroundColor,
                margin,
                width: '100vw',
                position: 'relative',
                left: '50%',
                right: '50%',
                marginLeft: '-50vw',
                marginRight: '-50vw'
            }}
        />
    );
};

Divider.propTypes = {
    height: PropTypes.string,
    backgroundColor: PropTypes.string,
    margin: PropTypes.string
};

export default Divider;
